// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "科技论文写作",
      "tec": "史佳琪",
      "week": "1-8周",
      "add": "教学楼D座124新能"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "氢能技术及应用",
      "tec": "张代乐",
      "week": "1-8周",
      "add": "教学楼D座122新能"
    },
    0,
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "新能源汽车",
      "tec": "孙文瑶",
      "week": "1-8周",
      "add": "教学楼D座121新能"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    0,
    0,
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "储能工程经济性评估",
      "tec": "史佳琪",
      "week": "1-12周",
      "add": "教学楼D座122新能"
    },
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
